import { BaseApi, CancelTokenKeyCommit } from '@/main/baseApi';
import { SET_CANCEL_TOKEN } from '@/main/store/listEditTypes';

import { NAME, DMS_MODULE } from './constants';

const cancelInit: CancelTokenKeyCommit = { cancelTokenKey: null, commit: null };

class UzaverkaPokladenProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	filter({ cancelTokenKey, commit }: CancelTokenKeyCommit = cancelInit) {
		const cancelPtr = cancelTokenKey ? { value: null } : null;
		const resp = this.fetch(`${this.apiPath}FilterUzaverky`, undefined, { cancelPtr });

		cancelTokenKey && commit!(SET_CANCEL_TOKEN, { cancelTokenKey, token: cancelPtr!.value });

		return resp;
	}

	async uzaverkaUcetni(filter: any) {
		// eslint-disable-next-line max-len
		return this.post(`/${DMS_MODULE}/${NAME}/UzaverkaUcetni?TypId=${filter.TypId}&DoKdy=${filter.DoKdy}&PracovnikId=${filter.PracovnikId}&ProvozovnaId=${filter.ProvozovnaId}`);
	}
}

export const apiProvider = new UzaverkaPokladenProvider();
